module.exports = __webpack_public_path__ + "f4ed2b24d3d8f096240f17cfd2b4170b.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bold-webfont.woff
 ** module id = 375
 ** module chunks = 0
 **/